import React, { createContext, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { id as orderDateId } from '../../../filters/options/order-date';
import { useLinkedQuicksearchParams } from '../../hooks';

const AdvancedSearchOrderContext = createContext();

const defaultFilters = [
  {
    id: orderDateId,
    value: {
      from: moment().add(-90, 'days').toISOString(),
    },
  },
];

const AdvancedSearchOrderContextProvider = ({ children }) => {
  const quickSearchFilters = useLinkedQuicksearchParams();

  const [filters, setFilters] = useState(() => quickSearchFilters ?? defaultFilters);

  const updateFilter = useCallback((id, value, operator) => {
    const updatedFilter = { id, value, operator };
    const isArrayValueNullOrEmpty = (Array.isArray(value) && value.length === 0) || value[0] === '';

    setFilters((prevFilters) => {
      const otherFilters = prevFilters.filter((filter) => filter.id !== id);

      if (isArrayValueNullOrEmpty) {
        return otherFilters.length === prevFilters.length ? prevFilters : otherFilters;
      }

      return [...otherFilters, updatedFilter];
    });
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  const value = useMemo(
    () => ({
      filters,
      setFilters,
      updateFilter,
      resetFilters,
    }),
    [filters, setFilters, updateFilter, resetFilters],
  );

  return <AdvancedSearchOrderContext.Provider value={value}>{children}</AdvancedSearchOrderContext.Provider>;
};

AdvancedSearchOrderContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export { AdvancedSearchOrderContext, AdvancedSearchOrderContextProvider };
